// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDetailsBase, CriteriaDetailsBaseSchema } from 'api/gen/CriteriaDetailsBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Decimal43, Decimal43Schema } from 'api/gen/Decimal43';

const requiredPart = t.interface({
  tag: t.literal('SINGLE_DECIMAL_4_3'),
  value: t.union([Decimal43Schema, t.null]),
});

export const SingleDecimal43CriteriaDetailsSchema = excess(t.intersection([CriteriaDetailsBaseSchema.type, requiredPart]));

export interface SingleDecimal43CriteriaDetails extends t.TypeOf<typeof SingleDecimal43CriteriaDetailsSchema> {}
